(() => {
  const SIZE_KEY = "filter.v.option.size";
  const AVAIL_KEY = "filter.v.availability";
  const AVAIL_VAL = "1";

  function enforceInStockOnSize(urlString) {
    const url = new URL(urlString, window.location.origin);
    const params = url.searchParams;

    // Only enforce when a size filter is present
    if (params.has(SIZE_KEY) && params.get(AVAIL_KEY) !== AVAIL_VAL) {
      params.set(AVAIL_KEY, AVAIL_VAL);
      url.search = params.toString();
      return url.toString();
    }
    return null;
  }

  function applyIfNeeded(source) {
    const fixed = enforceInStockOnSize(window.location.href);
    if (fixed) {
      // Replace URL (avoid back-button loops)
      history.replaceState(history.state, "", fixed);

      // Many Shopify themes re-render via sections when the URL changes,
      // so force a reload to guarantee products match the enforced URL.
      // If you prefer "no reload", remove the line below.
      window.location.reload();
    }
  }

  // 1) On initial load
  applyIfNeeded("load");

  // 2) Catch theme AJAX updates (pushState/replaceState)
  const _pushState = history.pushState;
  const _replaceState = history.replaceState;

  history.pushState = function (...args) {
    _pushState.apply(this, args);
    applyIfNeeded("pushState");
  };

  history.replaceState = function (...args) {
    _replaceState.apply(this, args);
    applyIfNeeded("replaceState");
  };

  // 3) Back/forward navigation
  window.addEventListener("popstate", () => applyIfNeeded("popstate"));

  // 4) Extra safety: when a facet input changes, enforce right away
  document.addEventListener("change", (e) => {
    const el = e.target;
    if (!el) return;

    // If it’s a facet input and relates to size, enforce
    if (el.name === SIZE_KEY || (typeof el.name === "string" && el.name.includes(SIZE_KEY))) {
      // give theme a moment to update URL, then enforce
      setTimeout(() => applyIfNeeded("change"), 50);
    }
  }, true);
})();